import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { UpperCasePipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { SeoService } from "../../core/services/seo.service";
import { APP_NAME, APP_CONSTANTS } from "../../core/constants/app.constants";

@Component({
  selector: "app-about-page",
  standalone: true,
  imports: [RouterLink, UpperCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./about-page.component.html",
  styleUrl: "./about-page.component.scss",
})
export class AboutPageComponent {
  readonly appName = APP_NAME;
  constructor() {
    inject(SeoService).updatePage({
      title: `About ${APP_NAME} | Anonymous Conversations Worldwide`,
      description: `Learn how ${APP_NAME} helps people meet through spontaneous, privacy-conscious anonymous text conversations worldwide.`,
      canonical: `${APP_CONSTANTS.siteUrl}/about/`,
    });
  }
}
